import { strings } from "assets/constants";
import priceFormatter from "./priceFormatter";
import { Platform } from "react-native";

const makeFactorPdfTemplate = (data: Array<TodayFactorT>) =>
  `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <style>
          @font-face {
            font-family: defaultFont;
            src: url(${
              Platform.OS === "android"
                ? "file:///android_asset/fonts/IRANYekanMobile-Regular-FA.ttf"
                : "/static/media/IRANYekanMobile-Regular-FA.423b61df834b3ad715b8.ttf"
            });
          }

          * {
            direction: rtl;
            font-family: defaultFont;
          }

          .container {
            width: 90%;
            margin: auto;
            min-width: 400px;
            max-width: 1024px;
          }

          .styled-table {
            width: 100%;
            font-size: 0.9em;
          }

          .styled-table th,
          .styled-table td {
            padding: 12px 15px;
          }

          .styled-table thead tr {
            color: #fff;
            text-align: right;
            background-color: #555;
          }

          .styled-table tbody tr {
            text-align: right;
            border-bottom: 1px solid #dddddd;
          }
    
          .styled-table tbody tr:nth-of-type(even) {
            background-color: #f3f3f3;
          }

          .header {
            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;
            background-color: #cdcdcd;
            padding-left:10px;
            padding-right:10px;
          }

          .logo {
            width: 100px;
            height: 100px;
            border-radius: 15%;
          }

          .company-name {
            font-size: 16px;
          }

          .total {
            display: flex;
            flex-flow: row;
            width: 90%;
            padding-left: 25px;
            padding-right: 25px;
            padding-vertical: 5px;
            margin: auto;
            font-size: large;
            margin-top: 10px;
            margin-bottom: 70px;
            border: 2px solid #aaa;
            justify-content: space-between;
            border-radius: 20px 20px 20px 20px;
          }
        </style>
      </head>
      <body>
          <div class="container">
            ${data
              ?.map((factor: TodayFactorT) => {
                return `
              <div class="header">
           
                <div>
                  <p class="company-name">${factor?.customer?.name}</p>
                  <p>فاکتور شماره: ${factor?.id}</p>
                </div>
                <div>
                  <p>ثبت سفارش: ${factor?.created_at}</p>
                  <p>تایید سفارش: ${factor?.change_status_at}</p>
                </div>
            </div>

            <table class="styled-table">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>محصول</th>
                  <th>تعداد</th>
                  <th>قیمت واحد</th>
                  <th>مجموع</th>
                </tr>
              </thead>
              <tbody>
                ${factor?.items
                  ?.map(
                    (item: any, key: number) =>
                      `<tr>
                <td>${key + 1}</td>
                <td>${item?.product?.title} / ${item?.attributes
                        ?.map(
                          (attr: any) =>
                            `${attr?.title
                              ?.replace("×", "*")
                              ?.split("*")
                              ?.reverse()
                              .join("*")}`
                        )
                        .join(" , ")}</td>
                <td>${item?.count}</td>
                <td>${priceFormatter(item?.price)}</td>
                <td>${priceFormatter(item?.total_price)}</td>
              </tr>`
                  )
                  .join("")}
              </tbody>
            </table>
            <div class="total">
              <p>جمع کل</p>
              <p>${
                priceFormatter(factor?.total_price) + " " + strings.currency
              }</p>
            </div>
            
              `;
              })
              .join("")}
          </div>
      </body>
    </html>    
    `;

export default makeFactorPdfTemplate;
